import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Segment,
  Label,
  Dropdown,
  Button,
  FormField,
  TextArea,
  Icon
} from 'semantic-ui-react'

const CardMedicationErrorWorkingUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardMedicationErrorWorkingUX-div-0"
        style={{ width : "100%", height: "100%" }}>
        <Segment
          id="CardMedicationErrorWorkingUX-Segment-1">
          <div
            className="--override-disabled --grey"
            id="CardMedicationErrorWorkingUX-div-2"
            style={{"width":"100%","height":"100%","display":"grid","position":"relative","rowGap":"10px","gridTemplateColumns":"repeat(6, 1fr)"}}>
            <div
              id="CardMedicationErrorWorkingUX-div-3"
              style={{gridArea: "1 / 1 / 2 / 5", display: "flex", alignItems: "center"}}>
              
              <label
                id="CardMedicationErrorWorkingUX-label-4"
                style={{fontSize: "1.2rem", fontWeight: "bold"}}>
                {props.title ? props.title : "รายงานอุบัติการณ์ความเสี่ยงและความคลาดเคลื่อนทางยา (Feedback Report)"}
              </label>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-5"
              style={{gridArea: "1 / 5 / 2 / 7", display: "flex", justifyContent: "flex-end", alignItems: "baseline"}}>
              
              <Label
                id="CardMedicationErrorWorkingUX-Label-6">
                {props.detail?.status}
              </Label>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-7"
              style={{gridArea: "2/ 1 / 3 / 7"}}>
              
              <div
                id="CardMedicationErrorWorkingUX-div-45"
                style={{display: "grid", width: "100%"}}>
                
                <div
                  id="CardMedicationErrorWorkingUX-div-49"
                  style={{width: "100%"}}>
                  
                  <hr
                    id="CardMedicationErrorWorkingUX-hr-50">
                  </hr>
                </div>
                <div
                  id="CardMedicationErrorWorkingUX-div-48">
                  {props.errorMessage}
                </div>
              </div>
              <div
                id="CardMedicationErrorWorkingUX-div-85"
                style={{display: !!props.quarterDetail ? "flex" :"none", flexDirection: "column", alignItems: "center", lineHeight: 1.75, margin: "0.25rem 0"}}>
                
                <div
                  id="CardMedicationErrorWorkingUX-div-86">
                  {}
                </div>
                <div
                  id="CardMedicationErrorWorkingUX-div-92"
                  style={{display: "flex"}}>
                  
                  <div
                    id="CardMedicationErrorWorkingUX-div-93"
                    style={{fontWeight: "bold"}}>
                    {`ไตรมาสที่ ${props.quarterDetail?.quarter || ""}${props.quarterDetail?.quarter || props.quarterDetail?.year ? "/" : ""}${props.quarterDetail?.year || ""}`}
                  </div>
                  <div
                    id="CardMedicationErrorWorkingUX-div-94"
                    style={{cursor: "pointer", marginLeft: "1rem", marginTop: "-1px", display: props.hideEditQuarter ? "none":""}}>
                    
                    <Icon
                      className="yellow"
                      id="CardMedicationErrorWorkingUX-Icon-95"
                      name="edit"
                      onClick={props.onOpenModSelectQuarter}>
                    </Icon>
                  </div>
                </div>
                <div
                  id="CardMedicationErrorWorkingUX-div-87"
                  style={{fontWeight: "bold"}}>
                  {`ระหว่างวันที่ ${props.quarterDetail?.startDate || ""}${props.quarterDetail?.startDate || props.quarterDetail?.endDate ? " - " : ""}${props.quarterDetail?.endDate || ""}`}
                </div>
              </div>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-9"
              style={{gridArea: "3/ 1 / 4 / 2", display: "flex", marginTop: "5px"}}>
              
              <label
                id="CardMedicationErrorWorkingUX-label-10">
                {props.languageUX === "en" ? "Incorrect Listing" : "รายการที่คลาดเคลื่อน"}
              </label>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-11"
              style={{gridArea: "3/ 2 / 4 / 7"}}>
              
              <div
                className="ui label large"
                id="CardMedicationErrorWorkingUX-div-44"
                style={{display: "flex"}}>
                {`[${props.drugCode || ""}][${props.drugName || ""}]`}
              </div>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-77"
              style={{gridArea: "4/ 1 / 5 / 2", display: "flex", alignItems: "center"}}>
              
              <label
                id="CardMedicationErrorWorkingUX-label-81">
                {props.languageUX === "en" ? "Patient's first and last name" : "ชื่อ - สกุลผู้ป่วย"}
              </label>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-78"
              style={{gridArea: "4/ 2 / 5 / 4"}}>
              
              <div
                className="ui label large"
                id="CardMedicationErrorWorkingUX-div-83"
                style={{display: "flex"}}>
                {props.patientName || "-"}
              </div>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-79"
              style={{gridArea: "4 / 4 / 5 / 5", display: "flex", alignItems: "center"}}>
              
              <label
                id="CardMedicationErrorWorkingUX-label-82"
                style={{marginLeft: props.editMode ? "25%" : "35%"}}>
                {props.languageUX === "en" ? "Ordering agency" : "หน่วยงานที่สั่ง"}
              </label>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-80"
              style={{gridArea: "4 / 5 / 5 / 7"}}>
              
              <div
                className="ui label large"
                id="CardMedicationErrorWorkingUX-div-84"
                style={{display: "flex"}}>
                {props.divisionName || "-"}
              </div>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-14"
              style={{gridArea: props.editMode ? "6/ 1 / 7 / 2": "5/ 1 / 6 / 2", display: "flex", alignItems: "center"}}>
              
              <label
                id="CardMedicationErrorWorkingUX-label-15"
                style={{color: "red"}}>
                {props.languageUX === "en" ? "Associate physician*" : "แพทย์ผู้เกี่ยวข้อง*"}
              </label>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-16"
              style={{gridArea: props.editMode ? "6 / 2 / 7 / 4":"5/ 2 / 6 / 4"}}>
              
              <div
                id="CardMedicationErrorWorkingUX-div-17">
                {props.userSearch}
              </div>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-18"
              style={{gridArea: "5 / 4 / 6 / 5", alignItems: "center", display: props.editMode ? "none" : "flex"}}>
              
              <label
                id="CardMedicationErrorWorkingUX-label-19"
                style={{marginLeft: "35%"}}>
                {props.languageUX === "en" ? "Risk" : "เสี่ยง"}
              </label>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-20"
              style={{gridArea: "5 / 5 / 6 / 7", display: props.editMode ? "none" : ""}}>
              
              <Dropdown
                disabled={props.readOnly}
                fluid={true}
                id="CardMedicationErrorWorkingUX-Dropdown-21"
                name="risk_type"
                onChange={props.onChange}
                options={props.riskTypeOptions}
                selection={true}
                value={props.riskType}>
              </Dropdown>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-22"
              style={{gridArea: props.editMode ? "5 / 4 / 6 / 5": "6/ 1 / 7 / 2", display: "flex", alignItems: "center"}}>
              
              <label
                id="CardMedicationErrorWorkingUX-label-23"
                style={{color: "red",marginLeft: props.editMode ? "25%" : "", lineHeight: 1.35}}>
                {props.languageUX === "en" ? "Risk Types" : "ประเภทความเสี่ยง"}
              </label>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-24"
              style={{gridArea:  props.editMode ? "5 / 5 / 6 / 7" :  "6 / 2 / 7 / 4"}}>
              
              <Dropdown
                disabled={props.readOnly}
                fluid={true}
                id="CardMedicationErrorWorkingUX-Dropdown-25"
                name="type"
                onChange={props.onChange}
                options={props.typeOptions}
                selection={true}
                value={props.type}>
              </Dropdown>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-26"
              style={{gridArea: "6 / 4 / 7 / 5", display: "flex", alignItems: "center"}}>
              
              <label
                id="CardMedicationErrorWorkingUX-label-27"
                style={{marginLeft: props.editMode ? "25%" : "35%", lineHeight: 1.35}}>
                {props.editMode ? "ผลกระทบที่อาจเกิดขึ้น" :"Category"}
              </label>
              <div
                id="CardMedicationErrorWorkingUX-div-51">
                {props.Tooltip}
              </div>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-28"
              style={{gridArea: "6/ 5 / 7/ 7"}}>
              
              <Dropdown
                disabled={props.readOnly}
                fluid={true}
                id="CardMedicationErrorWorkingUX-Dropdown-29"
                name="category"
                onChange={props.onChange}
                options={props.categoryOptions}
                selection={true}
                value={props.category}>
              </Dropdown>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-30"
              style={{gridArea: "7 / 1 / 8 / 2", display: "flex", alignItems: "center"}}>
              
              <label
                id="CardMedicationErrorWorkingUX-label-31"
                style={{color: "red"}}>
                {props.languageUX === "en" ? "Risk topic *" : "หัวข้อความเสี่ยงเรื่อง *"}
              </label>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-32"
              style={{gridArea: "7/ 2 / 8/ 7"}}>
              
              <Dropdown
                allowAdditions={true}
                disabled={props.readOnly}
                fluid={true}
                id="CardMedicationErrorWorkingUX-Dropdown-33"
                multiple={true}
                name="type_detail"
                onAddItem={props.onAddOptions}
                onChange={props.onChange}
                options={props.typeDetailOptions}
                search={true}
                selection={true}
                value={props.typeDetail}>
              </Dropdown>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-34"
              style={{gridArea: "8/ 1 / 9 / 2", display:"flex", alignItems: "center"}}>
              
              <label
                id="CardMedicationErrorWorkingUX-label-35">
                {props.languageUX === "en" ? "cause" : "สาเหตุ"}
              </label>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-36"
              style={{gridArea: "8 / 2 / 9 / 7",display: ""}}>
              
              <Dropdown
                disabled={props.readOnly}
                fluid={true}
                id="CardMedicationErrorWorkingUX-Dropdown-37"
                multiple={true}
                name="cause"
                onChange={props.onChange}
                options={props.causeOptions}
                selection={true}
                value={props.cause}>
              </Dropdown>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-38"
              style={{gridArea: "9 / 1 / 10 / 2", display: "flex", alignItems: "center"}}>
              
              <label
                id="CardMedicationErrorWorkingUX-label-39">
                {props.languageUX === "en" ? "Event details" : "รายละเอียดเหตุการณ์"}
              </label>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-40"
              style={{gridArea: "9 / 2 / 10 / 7"}}>
              
              <Dropdown
                allowAdditions={true}
                disabled={props.readOnly}
                fluid={true}
                id="CardMedicationErrorWorkingUX-Dropdown-41"
                multiple={true}
                name="cause_detail"
                onAddItem={props.onAddOptions}
                onChange={props.onChange}
                options={props.causeDetailOptions}
                search={true}
                selection={true}
                value={props.causeDetail}>
              </Dropdown>
            </div>
            <div
              className="ui form"
              id="CardMedicationErrorWorkingUX-div-52"
              style={{gridArea: "10/ 1 /11/ 2", display: "flex", alignItems: "center"}}>
              
              <label
                id="CardMedicationErrorWorkingUX-label-53"
                style={{marginTop: "-0.95rem"}}>
                {props.editMode ? "แจ้งไปยัง" : "วันที่พบปัญหา"}
              </label>
            </div>
            <div
              className="ui form"
              id="CardMedicationErrorWorkingUX-div-54"
              style={{gridArea: "10/ 2 /11 / 7", display: "flex", alignItems: "center"}}>
              
              <FormField
                className={props.editMode ? "hidden" : ""}
                id="CardMedicationErrorWorkingUX-FormField-63"
                inline={true}>
                <div
                  id="CardMedicationErrorWorkingUX-div-72"
                  style={{width: "100%"}}>
                  {props.StartDate}
                </div>
              </FormField>
              <FormField
                className={props.editMode ? "hidden":""}
                id="CardMedicationErrorWorkingUX-FormField-65"
                inline={true}>
                <label
                  id="CardMedicationErrorWorkingUX-label-66"
                  style={{color: "red", padding: "0 1rem"}}>
                  {props.languageUX === "en" ? "Report to*" : "แจ้งไปยัง*"}
                </label>
              </FormField>
              <FormField
                id="CardMedicationErrorWorkingUX-FormField-67"
                inline={true}
                width={3}>
                <Dropdown
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardMedicationErrorWorkingUX-Dropdown-69"
                  name="editor_by"
                  onChange={props.onChange}
                  options={[{key: 1 ,text: "คลินิก", value:"CLINIC"},{key: 2 ,text: "เจ้าหน้าที่", value:"STAFF"}]}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.editorBy || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardMedicationErrorWorkingUX-FormField-70">
                <div
                  id="CardMedicationErrorWorkingUX-div-71"
                  style={{width: "100%"}}>
                  {props.staffSearch}
                </div>
              </FormField>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-73"
              style={{gridArea: "11/ 1 / 13 / 2", display: props.showSolution || props.detail.status === "COMPLETED" ? "flex":"none", alignItems: "baseline"}}>
              
              <label
                id="CardMedicationErrorWorkingUX-label-75"
                style={{paddingTop: "5px"}}>
                {props.languageUX === "en" ? "Corrective action guidelines" : "แนวทางการแก้ไข"}
              </label>
            </div>
            <div
              className="ui form"
              id="CardMedicationErrorWorkingUX-div-74"
              style={{gridArea: "11/ 2/ 13/ 7", display: props.showSolution || props.detail.status === "COMPLETED" ? "flex":"none", alignItems: "center", paddingBottom: !props.showSolution?"1rem":""}}>
              
              <TextArea
                disabled={props.detail.status === "COMPLETED"}
                id="CardMedicationErrorWorkingUX-TextArea-76"
                name="solution_note"
                onChange={props.onChange}
                value={props.solutionNote || ""}>
              </TextArea>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-42"
              style={{gridArea: props.showSolution ? "13/ 1 / 14/ 7":"11/ 1 / 12/ 7", display: "flex", justifyContent: "flex-end", padding: "5px 0"}}>
              
              <Button
                color={props.detail.pk ? "yellow" : "green"}
                disabled={props.disabledEdit || false}
                id="CardMedicationErrorWorkingUX-Button-43"
                onClick={props.onEdit}
                style={{display: !props.showButtonSave?"none":""}}>
                {props.detail.pk ? "EDIT" : "SAVE"}
              </Button>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-88"
              style={{gridArea: "5/ 1 / 6 / 2",  display: props.editMode ? "flex":"none", alignItems: "center"}}>
              
              <label
                id="CardMedicationErrorWorkingUX-label-90">
                {props.languageUX === "en" ? "Date of incident" : "วันที่เกิดเหตุ"}
              </label>
            </div>
            <div
              id="CardMedicationErrorWorkingUX-div-89"
              style={{gridArea: "5/ 2 / 6 / 4",  display: props.editMode ? "flex":"none", alignItems: "center"}}>
              
              <div
                className="ui label large"
                id="CardMedicationErrorWorkingUX-div-91"
                style={{flex: 1}}>
                {props.incidentDate || "-"}
              </div>
            </div>
          </div>
        </Segment>
      </div>
    )
}


export default CardMedicationErrorWorkingUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Mon Aug 18 2025 09:30:53 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width : \"100%\", height: \"100%\" }"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Segment",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-Segment-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"position\":\"relative\",\"rowGap\":\"10px\",\"gridTemplateColumns\":\"repeat(6, 1fr)\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"1 / 1 / 2 / 5\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "label",
      "parent": 3,
      "props": {
        "children": {
          "type": "code",
          "value": "props.title ? props.title : \"รายงานอุบัติการณ์ความเสี่ยงและความคลาดเคลื่อนทางยา (Feedback Report)\""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-label-4"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.2rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"1 / 5 / 2 / 7\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"baseline\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Label",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.detail?.status"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-Label-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"2/ 1 / 3 / 7\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"3/ 1 / 4 / 2\", display: \"flex\", marginTop: \"5px\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการที่คลาดเคลื่อน",
          "valueEN": "Incorrect Listing"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-label-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"3/ 2 / 4 / 7\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: props.editMode ? \"6/ 1 / 7 / 2\": \"5/ 1 / 6 / 2\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์ผู้เกี่ยวข้อง*",
          "valueEN": "Associate physician*"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-label-15"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: props.editMode ? \"6 / 2 / 7 / 4\":\"5/ 2 / 6 / 4\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "code",
          "value": "props.userSearch"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-17"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"5 / 4 / 6 / 5\", alignItems: \"center\", display: props.editMode ? \"none\" : \"flex\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "label",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "เสี่ยง",
          "valueEN": "Risk"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-label-19"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"35%\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"5 / 5 / 6 / 7\", display: props.editMode ? \"none\" : \"\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Dropdown",
      "parent": 20,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-Dropdown-21"
        },
        "name": {
          "type": "value",
          "value": "risk_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "options": {
          "type": "code",
          "value": "props.riskTypeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.riskType"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: props.editMode ? \"5 / 4 / 6 / 5\": \"6/ 1 / 7 / 2\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "label",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทความเสี่ยง",
          "valueEN": "Risk Types"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-label-23"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\",marginLeft: props.editMode ? \"25%\" : \"\", lineHeight: 1.35}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{gridArea:  props.editMode ? \"5 / 5 / 6 / 7\" :  \"6 / 2 / 7 / 4\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Dropdown",
      "parent": 24,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-Dropdown-25"
        },
        "name": {
          "type": "value",
          "value": "type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "options": {
          "type": "code",
          "value": "props.typeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.type"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"6 / 4 / 7 / 5\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "label",
      "parent": 26,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editMode ? \"ผลกระทบที่อาจเกิดขึ้น\" :\"Category\""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-label-27"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: props.editMode ? \"25%\" : \"35%\", lineHeight: 1.35}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"6/ 5 / 7/ 7\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Dropdown",
      "parent": 28,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-Dropdown-29"
        },
        "name": {
          "type": "value",
          "value": "category"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "options": {
          "type": "code",
          "value": "props.categoryOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.category"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-30"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"7 / 1 / 8 / 2\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "label",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "หัวข้อความเสี่ยงเรื่อง *",
          "valueEN": "Risk topic *"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-label-31"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-32"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"7/ 2 / 8/ 7\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "Dropdown",
      "parent": 32,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-Dropdown-33"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "type_detail"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "options": {
          "type": "code",
          "value": "props.typeDetailOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.typeDetail"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-34"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"8/ 1 / 9 / 2\", display:\"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "label",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "สาเหตุ",
          "valueEN": "cause"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-label-35"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-36"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"8 / 2 / 9 / 7\",display: \"\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Dropdown",
      "parent": 36,
      "props": {
        "className": {
          "type": "code",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-Dropdown-37"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "cause"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "options": {
          "type": "code",
          "value": "props.causeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.cause"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"9 / 1 / 10 / 2\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "label",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดเหตุการณ์",
          "valueEN": "Event details"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-label-39"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"9 / 2 / 10 / 7\"}"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "Dropdown",
      "parent": 40,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "clearable": {
          "type": "code",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-Dropdown-41"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "cause_detail"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "options": {
          "type": "code",
          "value": "props.causeDetailOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.causeDetail"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: props.showSolution ? \"13/ 1 / 14/ 7\":\"11/ 1 / 12/ 7\", display: \"flex\", justifyContent: \"flex-end\", padding: \"5px 0\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Button",
      "parent": 42,
      "props": {
        "children": {
          "type": "code",
          "value": "props.detail.pk ? \"EDIT\" : \"SAVE\""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "code",
          "value": "props.detail.pk ? \"yellow\" : \"green\""
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledEdit || false"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-Button-43"
        },
        "onClick": {
          "type": "code",
          "value": "props.onEdit"
        },
        "style": {
          "type": "code",
          "value": "{display: !props.showButtonSave?\"none\":\"\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "code",
          "value": "`[${props.drugCode || \"\"}][${props.drugName || \"\"}]`"
        },
        "className": {
          "type": "value",
          "value": "ui label large"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-44"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-45"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", width: \"100%\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 45,
      "props": {
        "children": {
          "type": "code",
          "value": "props.errorMessage"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-48"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "hr",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-hr-50"
        }
      },
      "seq": 50,
      "void": true
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "code",
          "value": "props.Tooltip"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-51"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-52"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"10/ 1 /11/ 2\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "label",
      "parent": 52,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editMode ? \"แจ้งไปยัง\" : \"วันที่พบปัญหา\""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-label-53"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"-0.95rem\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-54"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"10/ 2 /11 / 7\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormField",
      "parent": 54,
      "props": {
        "className": {
          "type": "code",
          "value": "props.editMode ? \"hidden\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-FormField-63"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormField",
      "parent": 54,
      "props": {
        "className": {
          "type": "code",
          "value": "props.editMode ? \"hidden\":\"\""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-FormField-65"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "label",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "แจ้งไปยัง*",
          "valueEN": "Report to*"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-label-66"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", padding: \"0 1rem\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 54,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-FormField-67"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "Dropdown",
      "parent": 67,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-Dropdown-69"
        },
        "name": {
          "type": "value",
          "value": "editor_by"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "options": {
          "type": "code",
          "value": "[{key: 1 ,text: \"คลินิก\", value:\"CLINIC\"},{key: 2 ,text: \"เจ้าหน้าที่\", value:\"STAFF\"}]"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.editorBy || \"\""
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "FormField",
      "parent": 54,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-FormField-70"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 70,
      "props": {
        "children": {
          "type": "code",
          "value": "props.staffSearch"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-71"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "code",
          "value": "props.StartDate"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-72"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-73"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"11/ 1 / 13 / 2\", display: props.showSolution || props.detail.status === \"COMPLETED\" ? \"flex\":\"none\", alignItems: \"baseline\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-74"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"11/ 2/ 13/ 7\", display: props.showSolution || props.detail.status === \"COMPLETED\" ? \"flex\":\"none\", alignItems: \"center\", paddingBottom: !props.showSolution?\"1rem\":\"\"}"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "label",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": "แนวทางการแก้ไข",
          "valueEN": "Corrective action guidelines"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-label-75"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"5px\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 76,
      "name": "TextArea",
      "parent": 74,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.detail.status === \"COMPLETED\""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-TextArea-76"
        },
        "name": {
          "type": "value",
          "value": "solution_note"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "value": {
          "type": "code",
          "value": "props.solutionNote || \"\""
        }
      },
      "seq": 76,
      "void": true
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-77"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"4/ 1 / 5 / 2\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"4/ 2 / 5 / 4\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-79"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"4 / 4 / 5 / 5\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-80"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"4 / 5 / 5 / 7\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "label",
      "parent": 77,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ - สกุลผู้ป่วย",
          "valueEN": "Patient's first and last name"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-label-81"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "label",
      "parent": 79,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงานที่สั่ง",
          "valueEN": "Ordering agency"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-label-82"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: props.editMode ? \"25%\" : \"35%\"}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 78,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientName || \"-\""
        },
        "className": {
          "type": "value",
          "value": "ui label large"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-83"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "code",
          "value": "props.divisionName || \"-\""
        },
        "className": {
          "type": "value",
          "value": "ui label large"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-84"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-85"
        },
        "style": {
          "type": "code",
          "value": "{display: !!props.quarterDetail ? \"flex\" :\"none\", flexDirection: \"column\", alignItems: \"center\", lineHeight: 1.75, margin: \"0.25rem 0\"}"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-86"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "code",
          "value": "`ระหว่างวันที่ ${props.quarterDetail?.startDate || \"\"}${props.quarterDetail?.startDate || props.quarterDetail?.endDate ? \" - \" : \"\"}${props.quarterDetail?.endDate || \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-87"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-88"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"5/ 1 / 6 / 2\",  display: props.editMode ? \"flex\":\"none\", alignItems: \"center\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-89"
        },
        "style": {
          "type": "code",
          "value": "{gridArea: \"5/ 2 / 6 / 4\",  display: props.editMode ? \"flex\":\"none\", alignItems: \"center\"}"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "label",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่เกิดเหตุ",
          "valueEN": "Date of incident"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-label-90"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "code",
          "value": "props.incidentDate || \"-\""
        },
        "className": {
          "type": "value",
          "value": "ui label large"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-91"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "code",
          "value": "`ไตรมาสที่ ${props.quarterDetail?.quarter || \"\"}${props.quarterDetail?.quarter || props.quarterDetail?.year ? \"/\" : \"\"}${props.quarterDetail?.year || \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\", marginLeft: \"1rem\", marginTop: \"-1px\", display: props.hideEditQuarter ? \"none\":\"\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "Icon",
      "parent": 94,
      "props": {
        "className": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardMedicationErrorWorkingUX-Icon-95"
        },
        "name": {
          "type": "value",
          "value": "edit"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenModSelectQuarter"
        }
      },
      "seq": 95,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 45,
  "isMounted": true,
  "memo": false,
  "name": "CardMedicationErrorWorkingUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 60
}

*********************************************************************************** */
